// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
} from '../../utils/Styles/DataBoxStyles';
import CheckedIcon from '../../utils/CheckedIcon';

const StyledActions = styled.div`
  position: absolute;
  right: 0;
  top: 16px;
`;

const PartyAddMemberMobileTable = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  users,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onAddGuestClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  members,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  StyleAddGuestButton,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  StyledAddedNote,
}) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {users.map(user => (
        <StyledMobileBoxItem key={user.id}>
          <StyledMobileBoxItemRow>{user.name}</StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow>{user.email}</StyledMobileBoxItemRow>
          <StyledActions>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {members.some(member => member.memberId === user.id) ? (
              <StyledAddedNote>
                <CheckedIcon /> Added
              </StyledAddedNote>
            ) : (
              <StyleAddGuestButton onClick={() => onAddGuestClick(user)}>
                <span>+</span> Add Guest
              </StyleAddGuestButton>
            )}
          </StyledActions>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default PartyAddMemberMobileTable;
